import React, { useEffect, useRef, useState, useMemo } from "react";
import {
  Button,
  Grid,
  Typography,
  Tooltip,
  TextField,
  InputLabel,
  Select,
  MenuItem,
  FormControl,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import axios from "axios";
import Layout from "../../layout/Layout";
import { useNavigate, useParams } from "react-router-dom";
import {
  config,
  reportsAPI,
  projectMasterAPI,
  leaveAPI,
  handleHrMasterAPI,
  manageCompaniesAPI,
} from "../../config";
import DataTable from "react-data-table-component";
import { MobileDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import * as XLSX from "xlsx/xlsx.mjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import moment from "moment";
import { Link } from "react-router-dom";
import dayjs from "dayjs";
import BarChart from "../../components/charts/BarChart";
import BarChartTwoToneIcon from "@mui/icons-material/BarChartTwoTone";
import PieChartTwoToneIcon from "@mui/icons-material/PieChartTwoTone";
import RadarTwoToneIcon from "@mui/icons-material/RadarTwoTone";
import TimelineTwoToneIcon from "@mui/icons-material/TimelineTwoTone";
import DonutLargeTwoToneIcon from "@mui/icons-material/DonutLargeTwoTone";
import DonutSmallTwoToneIcon from "@mui/icons-material/DonutSmallTwoTone";
import BubbleChartTwoToneIcon from "@mui/icons-material/BubbleChartTwoTone";
import PieChart from "../../components/charts/PieChart";
import LineChart from "../../components/charts/LineChart";
import AreaChart from "../../components/charts/DoughnutChart";
import DoughnutChart from "../../components/charts/DoughnutChart";
import RadarChart from "../../components/charts/RadarChart";
import PoolAreaChart from "../../components/charts/PoolAreaChart";
import BubbleChart from "../../components/charts/BubbleChart";
import ScatterChart from "../../components/charts/ScatterChart";
import Charts2 from "../../components/charts/Charts2";
import AssessmentTwoToneIcon from "@mui/icons-material/AssessmentTwoTone";
import UpgradeTwoToneIcon from "@mui/icons-material/UpgradeTwoTone";
import { _getDropdownListData } from "../../service";

function AttendanceReport() {
  console.log("thispage");
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(10); //change to 10 after you remove paginationRowsPerPageOptions
  const [currentPage, setCurrentPage] = useState(1);

  let tempRefs = useRef(false);
  const handlePageChange = (page) => {
    tempRefs.current = false;
    getAttendanceReport(page, rowsPerPage);
    setCurrentPage(page);
  };

  const handleRowsPerPageChange = async (newRowsPerPage) => {
    tempRefs.current = false;
    getAttendanceReport(1, newRowsPerPage);
    setRowsPerPage(newRowsPerPage);
    setCurrentPage(1);
  };

  // const handleSort = (column, sortDirection) => {
  //   setLoading(true);
  //   setTimeout(() => {
  //     field = column.field;
  //     orderBy = sortDirection;
  //     setLoading(false);
  //   }, 100);
  // };

  const columns = useMemo(
    () => [
      {
        name: "Employee name",
        field: "id",
        width: "20%",
        sortable: true,
        selector: (row) => (row.employee_name ? row.employee_name : "-"),
      },
      {
        name: "Company name",
        field: "id",
        width: "15%",
        sortable: true,
        selector: (row) => (row.company_name ? row.company_name : "-"),
      },
      {
        name: "Date",
        field: "id",
        sortable: true,
        width: "11%",
        selector: (row) =>
          row.date ? moment(row.date).format("DD-MM-YYYY") : "-",
      },
      {
        name: "Start Time",
        field: "id",
        width: "10%",
        selector: (row) =>
          row.start_time ? moment(row.start_time).format("hh:mm A") : "-",
        center: true,
      },
      {
        name: "End Time",
        field: "id",
        width: "10%",
        selector: (row) =>
          row.end_time ? moment(row.end_time).format("hh:mm A") : "-",
        center: true,
      },

      {
        name: "Working Hours",
        field: "id",
        width: "10%",
        sortable: true,
        selector: (row) => (row.working_hours ? row.working_hours : "-"),
        center: true,
      },
      {
        name: "Shift",
        field: "id",
        sortable: true,
        selector: (row) => {
          switch (parseInt(row.Shift)) {
            case 1:
              return "Day Shift";
            case 2:
              return "Night Shift";
            default:
              return "-";
          }
        },
        center: true,
      },
      {
        name: "Attendance Status",
        field: "id",
        width: "10%",
        sortable: true,
        selector: (row) => {
          switch (row.attandence_status) {
            case 1:
              return "Full Day";
            case 2:
              return "Half Day";
            case 3:
              return "Leave";
            default:
              return "-";
          }
        },
        center: true,
      },
    ],
    []
  );

  const downloadExcel = () => {
    const data = {
      intEmployeeID: employeeID,
      txtFromDate: fromDate,
      txtToDate: toDate,
      intType: 9,
      intLimit: totalCount,
      intOffset: 0,
    };
    config.method = "POST";
    config.data = data;
    config.url = reportsAPI;

    axios(config)
      .then(function (response) {
        const newData = response.data["result"].map(
          ({ id, created_at, ...row }) => {
            // Modify start_time and end_time fields to show only time
            row.start_time = row.start_time
              ? moment(row.start_time).format("hh:mm A")
              : "-";
            row.end_time = row.end_time
              ? moment(row.end_time).format("hh:mm A")
              : "-";

            // Modify attendance_status field based on status value
            switch (row.attandence_status) {
              case 1:
                row.attandence_status = "Full day";
                break;
              case 2:
                row.attandence_status = "Half day";
                break;
              case 3:
                row.attandence_status = "Leave";
                break;
              default:
                row.attandence_status = "-";
                break;
            }

            // Modify shift field based on shift value
            row.Shift =
              row.Shift == 1
                ? "Day shift"
                : row.Shift == 2
                ? "Night shift"
                : "-";

            return row;
          }
        );

        const workSheet = XLSX.utils.json_to_sheet(newData);
        const workBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(
          workBook,
          workSheet,
          "Employee Attendance Report"
        );
        //Buffer
        let buf = XLSX.write(workBook, { bookType: "xlsx", type: "buffer" });
        //Binary string
        XLSX.write(workBook, { bookType: "xlsx", type: "binary" });
        //Download
        XLSX.writeFile(
          workBook,
          `TT-Attendance-report-${moment().format("DD-MM-YYYY")}.xlsx`
        );
      })
      .catch(function (error) {
        if (error.message === "Network Error") {
          localStorage.removeItem("user");
          window.location.href = window.location.origin + "/";
        }
        console.log(error);
      });
  };

  const [attendanceReport, setAttendanceReport] = useState([]);
  const [fromDate, setFromDate] = React.useState(dayjs());
  const [toDate, setToDate] = React.useState(dayjs());
  const [totalCount, setTotalCount] = React.useState(0);

  const getAttendanceReport = (page, rowsPerPage) => {
    const data = {
      intEmployeeID: employeeID,
      intCompanyName: companyName,
      txtFromDate: fromDate.format("YYYY-MM-DD"),
      txtToDate: toDate.format("YYYY-MM-DD"),
      intLimit: rowsPerPage ? rowsPerPage : 10,
      intOffset: rowsPerPage ? (page - 1) * rowsPerPage : 0,
      intType: 9,
    };
    // console.clear();
    console.log(data);

    config.method = "POST";
    config.data = JSON.stringify(data);
    config.url = reportsAPI;

    axios(config)
      .then(function (response) {
        console.clear();
        console.log(response.data);
        setAttendanceReport(response.data.result);
        setTotalCount(response.data.totalCount);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  let tempRefs1 = useRef(false);

  useEffect(() => {
    if (tempRefs1.current === false) {
      getAttendanceReport(1, rowsPerPage);
      return () => {
        tempRefs1.current = true;
      };
    }
  }, []);

  const [employeeID, setEmployeeID] = useState(0);
  const [EmployeeList, setEmployeeList] = useState([]);
  let tempRefs2 = useRef(false);
  console.log(attendanceReport);

  useEffect(() => {
    if (tempRefs2.current === false) {
      const data = {
        intType: 7,
      };

      config.method = "POST";
      config.data = JSON.stringify(data);
      config.url = handleHrMasterAPI;

      axios(config)
        .then(function (response) {
          console.log({ hr: response.data.result });
          setEmployeeList(response.data.result);
        })
        .catch(function (error) {
          console.log(error);
        });
      return () => {
        tempRefs2.current = true;
      };
    }
  }, []);

  // Getting Company List
  const [companyList, setComanyList] = useState([]);
  const [companyName, setCompanyName] = useState("");

  useEffect(() => {
    let data = {
      requestData: {
        intType: 6,
      },
      API: manageCompaniesAPI,
      setData: setComanyList,
    };

    _getDropdownListData(data);
  }, []);

  console.log(companyList);

  const [isChartButtonClicked, setChartButtonClicked] = useState(false);
  const [bar, setBar] = useState(false);
  const [pie, setPie] = useState(false);
  const [line, setLine] = useState(false);
  const [area, setArea] = useState(false);
  const [radar, setRadar] = useState(false);
  const [doughnut, setDoughnut] = useState(false);
  const [polarArea, setPolarArea] = useState(false);
  const [bubble, setBubble] = useState(false);

  // const handleClick = (name) => {
  //   switch (name) {
  //     case 'bar': {
  //       setPie(false)
  //       setLine(false)
  //       setArea(false)
  //       setRadar(false)
  //       setDoughnut(false)
  //       setPolarArea(false)
  //       setBubble(false)
  //       setBar(true)
  //       break;
  //     }
  //     case 'pie': {
  //       setBar(false)
  //       setLine(false)
  //       setArea(false)
  //       setRadar(false)
  //       setDoughnut(false)
  //       setPolarArea(false)
  //       setBubble(false)
  //       setPie(true)
  //       break;
  //     }
  //     case 'line': {
  //       setBar(false)
  //       setPie(false)
  //       setArea(false)
  //       setRadar(false)
  //       setDoughnut(false)
  //       setPolarArea(false)
  //       setBubble(false)
  //       setLine(true)
  //       break;
  //     }
  //     case 'area': {
  //       setBar(false)
  //       setPie(false)
  //       setRadar(false)
  //       setDoughnut(false)
  //       setPolarArea(false)
  //       setBubble(false)
  //       setLine(false)
  //       setArea(true)
  //       break;
  //     }
  //     case 'radar': {
  //       setBar(false)
  //       setPie(false)
  //       setLine(false)
  //       setArea(false)
  //       setDoughnut(false)
  //       setPolarArea(false)
  //       setBubble(false)
  //       setRadar(true)
  //       break;
  //     }
  //     case 'doughnut': {
  //       setBar(false)
  //       setPie(false)
  //       setLine(false)
  //       setArea(false)
  //       setRadar(false)
  //       setPolarArea(false)
  //       setBubble(false)
  //       setDoughnut(true)
  //       break;
  //     }
  //     case 'pool': {
  //       setBar(false)
  //       setPie(false)
  //       setLine(false)
  //       setArea(false)
  //       setRadar(false)
  //       setDoughnut(false)
  //       setBubble(false)
  //       setPolarArea(true)
  //       break;
  //     }
  //     case 'bubble': {
  //       setBar(false)
  //       setPie(false)
  //       setLine(false)
  //       setArea(false)
  //       setRadar(false)
  //       setDoughnut(false)
  //       setPolarArea(false)
  //       setBubble(true)
  //       break;
  //     }

  //     default:
  //       break;
  //   }
  // }

  const chartContainerStyle = {
    width: "full", // Set your desired width
    height: "800px", // Set your desired height
    marginTop: "1rem",
    display: "flex",
    flexDirection: "column",
    // justifyContent: "center",
    alignItems: "center",
  };

  const buttonStyle = {
    margin: "5px 3px",
    padding: "0.5rem",
    borderRadius: "0.3em",
  };

  return (
    <Layout>
      <Grid className="employee-form">
        <Grid
          href="#top"
          container
          spacing={2}
          margin={`15px 0px`}
          padding={`10px 15px 0px 0px`}
        >
          <Grid item xs={12} lg={3} md={3}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">
                Employee List
              </InputLabel>
              <Select
                labelId="Select Project"
                id="demo-simple-select"
                value={employeeID}
                label="Employee List"
                onChange={(e) => {
                  setEmployeeID(e.target.value);
                }}
              >
                {EmployeeList.map((row, index) => (
                  <MenuItem value={row.id} key={index}>
                    {row.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} lg={3} md={3}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">
                Company Name
              </InputLabel>
              <Select
                labelId="Select Project"
                id="demo-simple-select"
                value={companyName}
                label="Company name"
                onChange={(e) => {
                  setCompanyName(e.target.value);
                }}
              >
                {companyList.map((row, index) => (
                  <MenuItem value={row.id} key={index}>
                    {row.company_name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} lg={3} md={3}>
            <LocalizationProvider
              dateAdapter={AdapterDayjs}
              format="DD-MM-YYYY"
            >
              <MobileDatePicker
                label="Select From Date"
                value={fromDate}
                inputFormat="DD/MM/YYYY"
                fullWidth
                onChange={(e) => {
                  setFromDate(e);
                }}
                renderInput={(params) => <TextField {...params} fullWidth />}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12} lg={3} md={3}>
            <LocalizationProvider
              dateAdapter={AdapterDayjs}
              format="DD-MM-YYYY"
            >
              <MobileDatePicker
                label="Select To Date"
                value={toDate}
                inputFormat="DD/MM/YYYY"
                fullWidth
                onChange={(e) => {
                  setToDate(e);
                }}
                renderInput={(params) => <TextField {...params} fullWidth />}
              />
            </LocalizationProvider>
          </Grid>

          <Grid item xs={12} lg={3} md={3}>
            <LoadingButton
              size="large"
              variant="contained"
              color="primary"
              onClick={() => {
                getAttendanceReport(1, rowsPerPage);
              }}
            >
              Search
            </LoadingButton>

            <LoadingButton
              size="large"
              variant="contained"
              color="primary"
              style={{ marginLeft: "10px" }}
              onClick={() => {
                setEmployeeID(0);
                setToDate(dayjs());
                setFromDate(dayjs());
                setCompanyName("");
              }}
            >
              Reset
            </LoadingButton>
          </Grid>
        </Grid>

        <Grid className="form_design" id="table">
          <Grid>
            {attendanceReport.length > 0 && (
              <>
                {/* <Grid
                  container
                  spacing={2}
                  margin={`15px 0px`}
                  padding={`10px 15px 0px 0px`}
                >
                  <Grid item xs={12} lg={4} md={4}>
                    <Typography>
                      Total Worked Time:{" "}
                      {`${totalHours} hours & ${totalMinutes} minutes`}
                    </Typography>
                    <Typography>{`${workingDays} days (8 hrs as 1 day)`}</Typography>
                  </Grid>
                  <Grid item xs={12} lg={4} md={4}>
                    <Typography>Total Amount Spent: {totalAmount}</Typography>
                  </Grid>
                  <Grid item xs={12} lg={4} md={4}>
                    <Typography>Total Amount Received: </Typography>
                  </Grid>
                </Grid> */}

                <Grid container spacing={3}>
                  <Grid item xs={12} lg={6} md={6}></Grid>
                  <Grid item xs={12} lg={6} md={6} textAlign="right">
                    <Button
                      href="#search"
                      className="btn-primary"
                      onClick={downloadExcel}
                      style={{ marginTop: "1rem" }}
                    >
                      Export to Excel
                    </Button>

                    <Button
                      // size="large"
                      href="#chart"
                      variant="contained"
                      className="btn-primary"
                      onClick={() => setChartButtonClicked(true)}
                      style={{ margin: "1rem 0 0 1rem" }}
                    >
                      view in chart
                      <AssessmentTwoToneIcon />
                    </Button>
                  </Grid>
                  <Grid item xs={12} lg={6} md={6}></Grid>
                </Grid>
              </>
            )}
            <DataTable
              pagination
              paginationServer
              // fixedHeader
              fixedHeaderScrollHeight="550px"
              columns={columns}
              data={attendanceReport}
              progressPending={loading}
              paginationTotalRows={totalCount}
              paginationDefaultPage={currentPage}
              paginationRowsPerPageOptions={[1, 10, 25, 50, 100, 500, 1000]} //you can remove it later, just to have more pages
              paginationPerPage={rowsPerPage}
              onChangePage={handlePageChange}
              // onSort={handleSort}
              onChangeRowsPerPage={handleRowsPerPageChange}
            />
          </Grid>

          {isChartButtonClicked && (
            <>
              <Grid className="form_design" id="chart">
                <Charts2 chartData={attendanceReport} />
              </Grid>

              <Grid
                style={{
                  display: "flex",
                  justifyContent: "right",
                  alignItems: "right",
                }}
              >
                <Button size="small" href="#top" className="btn-primary">
                  <UpgradeTwoToneIcon fontSize="small" /> Back To Top
                </Button>
              </Grid>
            </>
          )}
        </Grid>
      </Grid>
    </Layout>
  );
}

export default AttendanceReport;
